var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 16.054C18.3332 16.4961 18.1576 16.92 17.845 17.2325C17.5325 17.5451 17.1085 17.7207 16.6665 17.7207H3.33317C2.89114 17.7207 2.46722 17.5451 2.15466 17.2325C1.8421 16.92 1.6665 16.4961 1.6665 16.054V4.38737C1.6665 3.94534 1.8421 3.52142 2.15466 3.20886C2.46722 2.8963 2.89114 2.7207 3.33317 2.7207H7.49984L9.1665 5.2207H16.6665C17.1085 5.2207 17.5325 5.3963 17.845 5.70886C18.1576 6.02142 18.3332 6.44534 18.3332 6.88737V16.054Z",
    stroke: "#475467",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTab);
export default __webpack_public_path__ + "static/media/fileTab.953561f76769601b8f188b51a27d645c.svg";
export { ForwardRef as ReactComponent };